<template>
  <div>
      <div class="text-xl flex justify items-center flex-wrap mb-2">
          <div class="flex items-center mr-2">
            <span class="font-bold text-2xl mr-2">{{type}}</span>
            <vs-chip size="small" v-if="goodSentiment" color="success" class="m-0">
              good
            </vs-chip>
            <vs-chip size="small" v-else-if="neutral" color="dark" class="m-0">
              neutral
            </vs-chip>
            <vs-chip size="small" v-else color="danger" class="m-0">
              not so good
            </vs-chip>
          </div>
          <div>

          <div class="flex">
            <LifeArea v-for="lifeArea in story.whyDoYouFeelThatWay" :lifeArea="lifeArea" class="mr-1" :showIcon="true" :hideText="true"/>
          </div>

          </div>

        </div>
        <span v-if="chipTitle" class="text-xl mb-4">{{chipTitle}}</span>
        <div ><p v-for="d in splittedDescription">{{d}}<br></p></div>
    </div>

</template>

<script>
// import JourneyDay from './JourneyDay'
// import * as DateHelper from '@/helpers/date'
import _ from 'lodash'
import Story from '@/models/Story'
import LifeArea from './LifeArea'

export default {
  components: {
    LifeArea
  },
  props: ['story'],
  data () {
    return {
    }
  },
  computed: {
    type () {
      if (this.storyEntity.freeWrite()) {
        return 'journal'
      } else {
        return 'discovery question'
      }
    },
    showSentiment () {
      return this.storyEntity.sentiment()
    },
    storyEntity () {
      return new Story(this.story)
    },
    goodSentiment () {
      return this.story.sentiment === 'good'
    },
    neutral () {
      return this.story.sentiment === 'neutral'
    },
    description () {
      if (this.storyEntity.freeWrite()) {
        return this.story.freeWriteDescription
      } else {
        return this.story.getInspiredDescription
      }
    },
    splittedDescription () {
      return _.split(this.description.trim(), /\r?\n/)
    },
    chipTitle () {
      if (this.storyEntity.freeWrite()) {
        return ''
      } else {
        return this.story.getInspiredQuestion
      }
    },
    dotColor () {
      if (this.goodSentiment) {
        return 'success'
      } else if (this.neutral) {
        return 'primary'
      } else {
        return 'danger'
      }
    }
  },
  methods: {
    openContextMenu () {
      // this.$root.$emit('closeAllContextMenus')

      if (this.$refs.storyCtxMenu) {
        this.$refs.storyCtxMenu.open()
      }
    },
    getIcon (lifeArea) {
      return LifeAreas[lifeArea]['icon']
    },
  },
  created () {

    this.$root.$on('closeAllContextMenus', () => {
      if (this.$refs.storyCtxMenu) {
        this.$refs.storyCtxMenu.ctxVisible = false
      }
    })
  },
}
</script>

<style lang="scss">

.saved_review {
  .vx-card__header {
    padding: 0.6rem
  }
}

</style>
